import { useQuery } from "@tanstack/react-query";
import { fetchData } from "../../services/api";
import {apiTimeExceededErrorMessages, parkingQueryKeys} from "../../constants";
import { minutes } from "utils/time";
import { IParkingPriceResponse } from "types/parkingSection.type";

interface IUseGetParkingPriceParams {
    sectionCode: string | null;
    parkMachineCode: string | null;
    licensePlate: string;
    tariff?: string;
    requestedMinutes?: number;
}


export const useGetParkingPrice = ({ licensePlate, sectionCode, parkMachineCode, requestedMinutes }: IUseGetParkingPriceParams) => {
    return useQuery({
        queryKey: parkingQueryKeys.price.get(sectionCode, licensePlate, requestedMinutes, parkMachineCode),
        staleTime: 0,
        gcTime: minutes(1),
        enabled: (!!sectionCode || !!parkMachineCode) && requestedMinutes > 0,
        queryFn: async (): Promise<IParkingPriceResponse> => {
            const response = await fetchData<IParkingPriceResponse>("Tickets/streetParking/calculateprice", "POST", "body", {
                licensePlate,
                sectionCode,
                parkMachineCode,
                requestedMinutes,
                shortenRequestedMinutesToMaxAllowed: false,
            });
            return response;
        },
        retry: (failureCount: number, error: Error): boolean => {
            if (apiTimeExceededErrorMessages.includes(error.message) || error.message.startsWith("Api Error: No valid parking duration found")) {
                return false;
            }
            return failureCount < 3;
        },
    });
};
